// frontend/src/components/blog/reader/BlogPreview.js
import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import BlogPostCard from "../common/BlogPostCard";
import "./BlogPreview.css";

const BlogPreview = () => {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [filter, setFilter] = useState("all");

  useEffect(() => {
    const fetchPosts = async () => {
      try {
        setLoading(true);
        const response = await axios.get(
          `${process.env.REACT_APP_API_BASE_URL}/blog/posts?status=published&isPublic=true`
        );
        setPosts(response.data);
      } catch (err) {
        setError("Failed to load blog previews");
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

    fetchPosts();
  }, []);

  const filteredPosts =
    filter === "all" ? posts : posts.filter((post) => post.category === filter);

  if (loading)
    return <div className="blog-loading">Loading blog previews...</div>;
  if (error) return <div className="blog-error">{error}</div>;

  return (
    <div className="blog-preview-container">
      <div className="blog-preview-header">
        <h1>Our Blog</h1>
        <p className="preview-message">
          Explore our latest articles and wellness insights.{" "}
          <Link to="/register">Create an account</Link> or{" "}
          <Link to="/login">log in</Link> to access full articles and exclusive
          content.
        </p>

        <div className="blog-filters">
          <button
            className={filter === "all" ? "active" : ""}
            onClick={() => setFilter("all")}
          >
            All
          </button>
          <button
            className={filter === "wellness" ? "active" : ""}
            onClick={() => setFilter("wellness")}
          >
            Wellness
          </button>
          <button
            className={filter === "treatments" ? "active" : ""}
            onClick={() => setFilter("treatments")}
          >
            Treatments
          </button>
          <button
            className={filter === "announcements" ? "active" : ""}
            onClick={() => setFilter("announcements")}
          >
            Announcements
          </button>
          <button
            className={filter === "tips" ? "active" : ""}
            onClick={() => setFilter("tips")}
          >
            Tips & Advice
          </button>
        </div>
      </div>

      {filteredPosts.length === 0 ? (
        <div className="no-posts">
          No preview posts available for this category
        </div>
      ) : (
        <div className="blog-posts-grid">
          {filteredPosts.map((post) => (
            <BlogPostCard key={post._id} post={post} isPreview={true} />
          ))}
        </div>
      )}

      <div className="cta-container">
        <h2>Want to read more?</h2>
        <p>
          Create an account to access all our blog content, full articles, and
          exclusive wellness resources.
        </p>
        <div className="cta-buttons">
          <Link to="/register" className="cta-button primary">
            Sign Up
          </Link>
          <Link to="/login" className="cta-button secondary">
            Log In
          </Link>
        </div>
      </div>
    </div>
  );
};

export default BlogPreview;
